import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LessonsDialog from './LessonsDialog';
import { withNamespaces } from 'react-i18next';

class LessonsButton extends Component {
	constructor(props) {
		super(props);
		this.showDialog = this.showDialog.bind(this);
		this.hideDialog = this.hideDialog.bind(this);
		this.state = { showDialog: false };
	}

	showDialog() {
		this.props.onClick();
		this.setState({ showDialog: true });
	}

	hideDialog() {
		this.setState({ showDialog: false });
	}

	render() {
		const { t, programItem, lessons, blocking } = this.props;
		return (
			<div>
				<a role='button' onClick={this.showDialog}>{t('FO_Child_HistoryDetails')}</a>
				<LessonsDialog
					show={this.state.showDialog}
					onCancel={this.hideDialog}
					title={programItem.grade.name}
					lessons={lessons}
					blocking={blocking}
					weeklyInfos={this.props.weeklyInfos}
					onLoadWeeklyInfo={this.props.onLoadWeeklyInfo}
					grades={this.props.grades}
					onSubGradeSelect={this.props.onSubGradeSelect}
					subGradeBlock={this.props.subGradeBlock}
					subGradeUnblock={this.props.subGradeUnblock}
					weeklyInfoBlock={this.props.weeklyInfoBlock}
					weeklyInfoUnblock={this.props.weeklyInfoUnblock}
					enableUserTimeZone={this.props.enableUserTimeZone}
					center={this.props.center}
				/>
			</div>
		);
	}
}

LessonsButton.propTypes = {
	programItem: PropTypes.shape({
		grade: PropTypes.shape({ name: PropTypes.string })
	}),
	lessons: PropTypes.array,
	onClick: PropTypes.func.isRequired,
	blocking: PropTypes.bool
};

export default withNamespaces()(LessonsButton);